import { Box, Grid, GridItem, Heading, HTMLChakraProps } from '@chakra-ui/react';
import { FC } from 'react';

import { ExtendedProfileInfo } from '@/components/ui/shared/profile/ExtendedProfileInfo/ExtendedProfileInfo';
import { ContactProfileModal } from '@/components/ui/shared/profile/ProfilesList/components/ContactProfileModal';
import { ThinProfile } from '@/resources/ThinProfile';

interface IProfileListProps extends HTMLChakraProps<'div'> {
  title: string;
  profiles: Array<ThinProfile>;
}

export const ProfileList: FC<IProfileListProps> = ({ title, profiles, ...rest }) => {
  return (
    <Box {...rest}>
      <Heading fontSize="xl" lineHeight={7} color="gray.900" mb={7}>
        {title}
      </Heading>
      <Grid gap={10} templateColumns={['repeat(1, 1fr)', null, 'repeat(2, 1fr)']} alignItems="center">
        {profiles.map((profile) => (
          <GridItem key={profile.id}>
            <ExtendedProfileInfo
              profile={profile}
              contactItem={profile.emailPublic && profile.email && <ContactProfileModal profile={profile} />}
            />
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};
